import { useMemo, useState } from "react";
import type { ReactNode } from "react";
import type { Lang } from "./dict";
import { LangContext, makeT, readStoredLang, STORAGE_KEY } from "./context";
import type { LangContextValue, TFn } from "./context";

export function LangProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>(readStoredLang);

  const value = useMemo<LangContextValue>(() => {
    const setLang = (next: Lang) => {
      setLangState(next);
      try {
        localStorage.setItem(STORAGE_KEY, next);
      } catch {
        // Persisting is best-effort; ignore storage failures.
      }
    };

    const t: TFn = makeT(lang);

    return { lang, setLang, t };
  }, [lang]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}
